import React, { Component } from 'react'; //different
import SweetAlert from 'react-bootstrap-sweetalert';
//import Paoyingchub from './game/paoyingchub';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import { isMobile } from 'react-device-detect';
import NavMenu from './navmenu';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import md5 from 'md5';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { t } from './i18n';
class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            prolistx: [],
            username: null,
            userid: null,
            showmodal: false,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            loginstate: false,
            fullname: null,
            lname: null,
            alert: null,
            depositstate: 0,
            depositamount: 0,
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            affpercent: 0,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            tblnextrank: [],
            tblrankall: [],
            tblprofile: [],
            prodetail: [],
            linkaff: "",
            picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
            proderedeem: [],
            buttoncliam: false,
            limit: null,
            rankpic: null,
            rankname: null,
            rankob: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }
    confirmdeposit = async (e, num) => {

        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;

        await instance.post("/api/v1/getredeempromotion", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    proderedeem: res.data.message.tblpromotionredeems,
                });

            }
        }).catch(async (err) => {
        });

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                ////////console.log(depositstate, num);
                if (num === 0) {
                    if (token != null) {
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            ////////console.log(res.data.picture)
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.picture
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("success", t(this.lang, 'mr_topup_min') + ' ' + this.state.limit.min + ' ' + t(this.lang, 'mr_baht_max') + ' ' + this.state.limit.max + ' ');
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    async componentDidMount() {
        this.promotionlist();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.setState({
                username: Username,
            });

        }
    }
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            //   console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'ap_session_expired'),
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ok')
                })
                window.location.href = '/';
            }
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    this.setState({
                        showmodal: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("success", t(this.lang, 'promo_not_eligible'));
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 204) {
                    e.preventDefault();

                    await this.notify("success", t(this.lang, 'promo_daily_used_up'));
                    return false;
                }
                else if (res.data.status === 202) {
                    e.preventDefault();

                    await this.notify("success", t(this.lang, 'promo_already_used'));
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("success", t(this.lang, 'ap_session_expired'));
                    window.location.href = '/';
                }
            });
        }
    }

    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", t(this.lang, 'promo_pending_deposit'));
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("success", t(this.lang, 'ap_session_expired'));
                window.location.href = '/';
            }
        });
    }
    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await Swal.fire({
                        title: 'Success!',
                        text: t(this.lang, 'coupon_success_title'),
                        icon: 'success',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    await this.notify("success", t(this.lang, 'coupon_success_title'));
                }
                else {
                    await this.notify("error", t(this.lang, 'invalid_coupon'));
                }
            });
        }
        else {
            await this.notify("error", t(this.lang, 'u3_not_logged_in_short'));
        }

    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "phoneNumber") {
                document.getElementById("phoneNumberforget").style = "";
                document.getElementById("checkotpforgetphone").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    render() {
        const { prodetail, picnonpro, username, prolistx } = this.state
        return (
            <>
                <div className="tt_l tt_full tt_content bg">
                    <div className="thaitheme_read">

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                            gap: 16,
                            padding: '8px 0',
                        }}>
                            {prolistx.map((prolists, index) => (
                                <div
                                    key={index}
                                    onClick={(e) => this.checkpro(e, prolists.no)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <img
                                        decoding="async"
                                        src={prolists.linkpicture}
                                        alt={prolists.proname}
                                        style={{
                                            width: '100%',
                                            display: 'block',
                                            borderRadius: 10,
                                            objectFit: 'cover',
                                        }}
                                    />
                                    <div style={{
                                        textAlign: 'center',
                                        color: '#000',
                                        fontSize: 16,
                                        fontWeight: 600,
                                        marginTop: 8,
                                        lineHeight: '1.4',
                                        padding: '0 4px',
                                    }}>
                                        {prolists.proname}
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>


                <div
                    className={this.state.showmodal ? "modal fade show" : ""}
                    id="show_img"
                    aria-labelledby="show_imgLabel"
                    tabIndex={-1}
                    aria-modal="true"
                    role="dialog"
                    style={{ display: this.state.showmodal ? "block" : "none" }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        style={{
                            maxWidth: 760,
                            width: "94%",
                            margin: "20px auto"
                        }}
                    >
                        <div
                            className="modal-content"
                            style={{
                                background: "linear-gradient(180deg, #151515 0%, #050505 100%)",
                                border: "1px solid rgba(249, 207, 149, 0.45)",
                                borderRadius: 22,
                                overflow: "hidden",
                                boxShadow: "0 20px 60px rgba(0,0,0,0.75)"
                            }}
                        >
                            <div
                                className="modal-header"
                                style={{
                                    borderBottom: "1px solid rgba(249, 207, 149, 0.25)",
                                    padding: "12px 16px",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ color: "#f9cf95", fontSize: 18, fontWeight: 700 }}>
                                    {t(this.lang, 'ap_promotion')}
                                </div>

                                <a
                                    href="#0"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ showmodal: false });
                                    }}
                                    style={{
                                        color: "#f9cf95",
                                        textDecoration: "none"
                                    }}
                                >
                                    ✕
                                </a>
                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    padding: 18,
                                    color: "#fff"
                                }}
                            >
                                {(prodetail.length === 0) ? (
                                    <div style={{ textAlign: "center" }}>
                                        <img
                                            src={picnonpro}
                                            alt="img_show_popup"
                                            style={{
                                                width: "100%",
                                                maxWidth: 680,
                                                borderRadius: 16,
                                                display: "block",
                                                margin: "0 auto"
                                            }}
                                        />

                                        <div
                                            style={{
                                                marginTop: 16,
                                                padding: "12px 16px",
                                                borderRadius: 14,
                                                background: "rgba(249, 207, 149, 0.12)",
                                                color: "#f9cf95",
                                                fontWeight: 700
                                            }}
                                        >
                                            {t(this.lang, 'terms_conditions')}
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 14,
                                                color: "#fff",
                                                fontSize: 16
                                            }}
                                        >
                                            {t(this.lang, 'ap_promo_not_active')}
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <img
                                            style={{
                                                display: prodetail.linkpicture !== null ? "block" : "none",
                                                width: "100%",
                                                maxWidth: 680,
                                                borderRadius: 16,
                                                margin: "0 auto 16px auto"
                                            }}
                                            src={prodetail.linkpicture}
                                            alt="img_show_popup"
                                        />

                                        <div
                                            style={{
                                                padding: "12px 16px",
                                                borderRadius: 14,
                                                background: "linear-gradient(90deg, #c69a5d 0%, #f9cf95 50%, #c69a5d 100%)",
                                                color: "#000",
                                                fontWeight: 800,
                                                textAlign: "center",
                                                fontSize: 17
                                            }}
                                        >
                                            {t(this.lang, 'terms_conditions')}
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 16,
                                                padding: "16px",
                                                borderRadius: 16,
                                                background: "rgba(255,255,255,0.06)",
                                                border: "1px solid rgba(255,255,255,0.08)",
                                                color: "#f5f5f5",
                                                fontSize: 15,
                                                lineHeight: "26px",
                                                textAlign: "left"
                                            }}
                                        >
                                            <section
                                                dangerouslySetInnerHTML={{
                                                    __html: prodetail.detail,
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: prodetail.prolist == 5 ? "none" : "block",
                                                marginTop: 18,
                                                textAlign: "center"
                                            }}
                                        >
                                            <button
                                                className="btn"
                                                style={{
                                                    display: username !== null ? "inline-block" : "none",
                                                    width: "100%",
                                                    maxWidth: 320,
                                                    padding: "13px 20px",
                                                    borderRadius: 999,
                                                    border: "none",
                                                    color: "#000",
                                                    fontSize: 17,
                                                    fontWeight: 800,
                                                    background: "linear-gradient(180deg, #ffe2ad 0%, #f9cf95 45%, #c69a5d 100%)",
                                                    boxShadow: "0 8px 20px rgba(249, 207, 149, 0.35)"
                                                }}
                                                onClick={(e) => this.redeempro(e, prodetail.no)}
                                            >
                                                {t(this.lang, 'ap_get_promo')}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div><div
                    className={this.state.showmodal ? "modal fade show" : ""}
                    id="show_img"
                    aria-labelledby="show_imgLabel"
                    tabIndex={-1}
                    aria-modal="true"
                    role="dialog"
                    style={{ display: this.state.showmodal ? "block" : "none" }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        style={{
                            maxWidth: 760,
                            width: "94%",
                            margin: "20px auto"
                        }}
                    >
                        <div
                            className="modal-content"
                            style={{
                                background: "linear-gradient(180deg, #151515 0%, #050505 100%)",
                                border: "1px solid rgba(249, 207, 149, 0.45)",
                                borderRadius: 22,
                                overflow: "hidden",
                                boxShadow: "0 20px 60px rgba(0,0,0,0.75)"
                            }}
                        >
                            <div
                                className="modal-header"
                                style={{
                                    borderBottom: "1px solid rgba(249, 207, 149, 0.25)",
                                    padding: "12px 16px",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ color: "#f9cf95", fontSize: 18, fontWeight: 700 }}>
                                    {t(this.lang, 'ap_promotion')}
                                </div>

                                <a
                                    href="#0"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ showmodal: false });
                                    }}
                                    style={{
                                        color: "#f9cf95",
                                        textDecoration: "none"
                                    }}
                                >
                                    ✕
                                </a>
                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    padding: 18,
                                    color: "#fff"
                                }}
                            >
                                {(prodetail.length === 0) ? (
                                    <div style={{ textAlign: "center" }}>
                                        <img
                                            src={picnonpro}
                                            alt="img_show_popup"
                                            style={{
                                                width: "100%",
                                                maxWidth: 680,
                                                borderRadius: 16,
                                                display: "block",
                                                margin: "0 auto"
                                            }}
                                        />

                                        <div
                                            style={{
                                                marginTop: 16,
                                                padding: "12px 16px",
                                                borderRadius: 14,
                                                background: "rgba(249, 207, 149, 0.12)",
                                                color: "#f9cf95",
                                                fontWeight: 700
                                            }}
                                        >
                                            {t(this.lang, 'terms_conditions')}
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 14,
                                                color: "#fff",
                                                fontSize: 16
                                            }}
                                        >
                                            {t(this.lang, 'ap_promo_not_active')}
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <img
                                            style={{
                                                display: prodetail.linkpicture !== null ? "block" : "none",
                                                width: "100%",
                                                maxWidth: 680,
                                                borderRadius: 16,
                                                margin: "0 auto 16px auto"
                                            }}
                                            src={prodetail.linkpicture}
                                            alt="img_show_popup"
                                        />

                                        <div
                                            style={{
                                                padding: "12px 16px",
                                                borderRadius: 14,
                                                background: "linear-gradient(90deg, #c69a5d 0%, #f9cf95 50%, #c69a5d 100%)",
                                                color: "#000",
                                                fontWeight: 800,
                                                textAlign: "center",
                                                fontSize: 17
                                            }}
                                        >
                                            {t(this.lang, 'terms_conditions')}
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 16,
                                                padding: "16px",
                                                borderRadius: 16,
                                                background: "rgba(255,255,255,0.06)",
                                                border: "1px solid rgba(255,255,255,0.08)",
                                                color: "#f5f5f5",
                                                fontSize: 15,
                                                lineHeight: "26px",
                                                textAlign: "left"
                                            }}
                                        >
                                            <section
                                                dangerouslySetInnerHTML={{
                                                    __html: prodetail.detail,
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: prodetail.prolist == 5 ? "none" : "block",
                                                marginTop: 18,
                                                textAlign: "center"
                                            }}
                                        >
                                            <button
                                                className="btn"
                                                style={{
                                                    display: username !== null ? "inline-block" : "none",
                                                    width: "100%",
                                                    maxWidth: 320,
                                                    padding: "13px 20px",
                                                    borderRadius: 999,
                                                    border: "none",
                                                    color: "#000",
                                                    fontSize: 17,
                                                    fontWeight: 800,
                                                    background: "linear-gradient(180deg, #ffe2ad 0%, #f9cf95 45%, #c69a5d 100%)",
                                                    boxShadow: "0 8px 20px rgba(249, 207, 149, 0.35)"
                                                }}
                                                onClick={(e) => this.redeempro(e, prodetail.no)}
                                            >
                                                {t(this.lang, 'ap_get_promo')}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );

    }
}
export default App;
